import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Form from '@/common/components/Form';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import useSyncLeadsCostForm from '../hooks/useSyncLeadsCostForm';
import Loading from '@/common/components/Loading';
import moment from 'moment';

const SyncLeadCostsForm = ({ setShow, account }) => {
	const hook = useSyncLeadsCostForm({ setShow });

	const maxDate = moment().subtract('1', 'day').format('YYYY-MM-DD');

	return (
		<>
			{hook.isLoading && <Loading />}
			<PopUp setShow={setShow}>
				<Form onSubmit={(e) => hook.handleSubmit(e, account)}>
					<h3 style={{ color: Colors.darkBlue }}>Sync Leads Costs</h3>
					<div style={{ margin: '60px 0' }}>
						<Input
							type='date'
							inputRef={hook.fromDateRef}
							name='From Date'
							color={Colors.darkBlue}
							width={150}
							requiredSign={true}
							max={maxDate}
						/>
						<Input
							type='date'
							inputRef={hook.toDateRef}
							name='To Date'
							width={150}
							color={Colors.darkBlue}
							requiredSign={true}
							max={maxDate}
						/>
					</div>
					<SubmitButton
						text='Sync Costs'
						style={{ marginTop: '10px', marginLeft: 'auto' }}
					/>
				</Form>
			</PopUp>
		</>
	);
};

export default SyncLeadCostsForm;
